<template>
  <div class="text-grey">
    <el-popover placement="bottom" width="200" trigger="click" v-model="visible"
      v-if="![1, 2].includes(sale.sale_status_id)">
      <div class="row">
        <div class="col-12 mb-1 fa-sm d-flex justify-content-between">
          <strong>Invoice #{{ sale.ref_id }}</strong>
          <i class="fa fa-times has-interaction" @click="close"></i>
        </div>
        <div class="col-12">
          <el-date-picker :picker-options="pickerOptions" v-model="agent_settlement_date" type="date"
            value-format="yyyy-MM-dd" format="dd/MM/yyyy" placeholder="Pick a date" size="small" style="width: 180px;">
          </el-date-picker>
          <el-button type="primary" @click="onSubmit" class="action-btn rounded fa-sm mt-1" style="width: 180px;"
            size="small">
            Request change settlement
          </el-button>
        </div>
      </div>
      <div slot="reference">
        {{ sale.confirmed_settlement_date ?
          moment(sale.confirmed_settlement_date).format('DD/MM/YYYY')
          :
          '--' }}
        <i class="el-icon-date"></i>
      </div>
    </el-popover>
  </div>
</template>
<script>
import Sale from "../../../modelsPortal/Sale";
export default {
  props: {
    initial_sale: {
      type: Object,
    },
  },
  mounted() {

  },
  data() {
    return {
      sale: this.initial_sale,
      agent_settlement_date: null,
      visible: false,
      pickerOptions: {
        disabledDate(time) {
          return time.getTime() < Date.now();
        },
      },
    };
  },
  methods: {
    close() {
      this.agent_settlement_date = null;
      this.visible = false;
    },
    onSubmit() {
      new Sale({
        id: this.sale.id,
        agent_settlement_date: this.agent_settlement_date,
        sale_status_id: 2,
      })
        .save()
        .then((result) => {
          this.sale.agent_settlement_date = this.agent_settlement_date;
          this.close();
          this.$message.success("Request created!");
        }).catch((err) => {

        });
    }
  },
};
</script>